// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"859c885e","863":"7d7c9b16"}[chunkId] + ".chunk.js";
};